// extracted by mini-css-extract-plugin
module.exports = {"highlightDefault":"_6wVmYZ","highlightDoggie":"_3fzj6-"};